import { render, staticRenderFns } from "./VideoLinks.vue?vue&type=template&id=61216fbe&scoped=true"
import script from "./VideoLinks.vue?vue&type=script&lang=js"
export * from "./VideoLinks.vue?vue&type=script&lang=js"
import style0 from "./VideoLinks.vue?vue&type=style&index=0&id=61216fbe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61216fbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61216fbe')) {
      api.createRecord('61216fbe', component.options)
    } else {
      api.reload('61216fbe', component.options)
    }
    module.hot.accept("./VideoLinks.vue?vue&type=template&id=61216fbe&scoped=true", function () {
      api.rerender('61216fbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/canvas/components/editor/VideoLinks.vue"
export default component.exports